import { atom } from "recoil";


export const CartListState = atom({
    key: 'CartList',
    default: [],
});

// 팝업창
export const PopupState = atom({
    key: 'Popup',
    default: {
        ModalName:'PopupBase', 
        Page:<></>, 
        isHide:false, 
        isCancel:false, 
        Width:0, 
        Height:0, 
        Title: ""},
});



